import { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search, X, Filter } from 'lucide-react';
import { Button } from "@/components/ui/button";

export interface UserFilters {
  search: string;
  status: string;
  country: string;
  showDeleted: boolean;
}

interface Props {
  filters: UserFilters;
  onChange: (filters: UserFilters) => void;
}

export const UserFilters: FC<Props> = ({ filters, onChange }) => {
  const handleChange = (key: keyof UserFilters, value: string | boolean) => {
    onChange({ ...filters, [key]: value });
  };

  const handleReset = () => {
    const resetFilters = {
      search: '',
      status: 'all',
      country: 'all',
      showDeleted: false
    };
    onChange(resetFilters);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500" />
            <Input
              type="text"
              placeholder="Buscar por nombre, email o whatsapp..."
              className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 sm:w-[300px] pl-10"
              value={filters.search}
              onChange={(e) => handleChange('search', e.target.value)}
            />
          </div>
        </div>

        <Select
          value={filters.status}
          onValueChange={(value) => handleChange('status', value)}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Estado" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los estados</SelectItem>
            <SelectItem value="unconfirmed">Email no confirmado</SelectItem>
            <SelectItem value="trial">En trial</SelectItem>
            <SelectItem value="grace_period">En período de gracia</SelectItem>
            <SelectItem value="premium">Suscripción activa</SelectItem>
            <SelectItem value="expired">Expirados</SelectItem>
            <SelectItem value="deleted">Eliminados</SelectItem>
          </SelectContent>
        </Select>

        <Select
          value={filters.country}
          onValueChange={(value) => handleChange('country', value)}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="País" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos los países</SelectItem>
            <SelectItem value="AR">Argentina</SelectItem>
            <SelectItem value="BO">Bolivia</SelectItem>
            <SelectItem value="CL">Chile</SelectItem>
            <SelectItem value="CO">Colombia</SelectItem>
            <SelectItem value="CR">Costa Rica</SelectItem>
            <SelectItem value="EC">Ecuador</SelectItem>
            <SelectItem value="SV">El Salvador</SelectItem>
            <SelectItem value="GT">Guatemala</SelectItem>
            <SelectItem value="HN">Honduras</SelectItem>
            <SelectItem value="MX">México</SelectItem>
            <SelectItem value="NI">Nicaragua</SelectItem>
            <SelectItem value="PA">Panamá</SelectItem>
            <SelectItem value="PY">Paraguay</SelectItem>
            <SelectItem value="PE">Perú</SelectItem>
            <SelectItem value="DO">República Dominicana</SelectItem>
            <SelectItem value="UY">Uruguay</SelectItem>
            <SelectItem value="VE">Venezuela</SelectItem>
          </SelectContent>
        </Select>

        <Button
          variant="outline"
          size="icon"
          onClick={handleReset}
          className="h-10 w-10"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
